import './Navbar.css'
const Navbar = () => {
    return ( 
        <>
            <nav>
                <div className="linksContainer">
                    <div className="navLinks">
                        <a href="###">Home</a>
                        <a href="#slider">Recents</a>
                        <a href="#comingSoon">Trending</a>
                    </div>
                </div>
            </nav>
        </>
    );
}
 
export default Navbar;